import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const topMotorGearChoiceStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_APPBAR_BG: 'bg-[#22252c]',
  COMMONS_FOOTER_BG: 'bg-[#22252c]',
  HOMEPAGE_TOPRATED_BUTTON: 'border-white hover:border-white hover:bg-[#22252c] text-white',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#22252c]',
  HOMEPAGE_HEADER_BG: 'bg-[#22252c]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#22252c]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#22252c]',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#22252c] text-[#22252c] [&>svg>path]:stroke-[#22252c] [&>svg>g>path]:stroke-[#22252c] [&>svg>path]:fill-[#22252c] [&>svg>g>path]:fill-[#22252c]',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#22252c] text-[#22252c] [&>svg>path]:stroke-[#30292a] [&>svg>g>path]:stroke-[#30292a] [&>svg>path]:fill-[#30292a] [&>svg>g>path]:fill-[#30292a]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#22252c]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#22252c]',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#22252c]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#22252c]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#22252c]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#ff014a] [&>.vector-top>path]:fill-[#22252c] [&>.vector-bottom>path]:fill-[#22252c]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#ff014a] [&>circle]:stroke-[#ff014a] [&>path]:fill-[#22252c]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#30292a] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#30292a] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_LINK: 'text-[#30292a]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#30292a] [&_path]:fill-[#30292a] [&_path]:stroke-[#30292a]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#30292a]',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#30292a]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#30292a]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#30292a]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#30292a]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-[#ff014a]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#ff014a]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#ff014a]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#ff014a]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#ff014a]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#ff014a]',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#ff014a]',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#ff014a] text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#ff014a]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#ff014a]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#ff014a]',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
}
